document.addEventListener("DOMContentLoaded", ()=>{
    const splides = document.querySelectorAll(".featured-product-image-slider:not(.is-active.is-overflow.is-initialized)");

    if(splides.length){
        for(let i = 0; i < splides.length; i++){
            const settings = {
            arrows : false,
            type   : 'fade',
            perPage: 1,
            perMove: 1,
            focus  : 'left',
            rewind : true
            };
            const splide = new Splide( splides[i], settings ); 
            splide.mount();
        }
    }
})

document.addEventListener('click', function(event) {
    if (event.target.matches('.featured-product-image-slider .splide__pagination .splide__pagination__page')) {
        event.preventDefault();
        event.stopPropagation();
    }
});